import React from "react";
import styled from "styled-components";

import NanoFlex from "./../Global/NanoFlex";

const StyledLoading = styled.div`
  position: relative;
  z-index: 2;
  .loading-container {
    position: relative;
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    animation: bckScale 1.6s ease infinite;
    transform: scale(0.6);
    .icon-background {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 8;
    }
    .squaresContainer {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      z-index: 1;
      animation: zIndex 1.6s ease-in-out infinite;
      .square {
        background: #00a8e1;
        height: 20px;
        width: 20px;
        margin: 0;
        animation: scaleSquare1 1.6s ease-in-out infinite;
      }

      .s2 {
        animation-delay: 0.01s;
      }
      .s3 {
        animation-delay: 0.02s;
      }
      .s4 {
        animation-delay: 0.03s;
      }
      .s5 {
        animation-delay: 0.04s;
      }
      .s6 {
        animation-delay: 0.05s;
      }
      .s7 {
        animation-delay: 0.06s;
      }
      .s8 {
        animation-delay: 0.07s;
      }
      .s9 {
        animation-delay: 0.08s;
      }
      .s10 {
        animation-delay: 0.09s;
      }
      .s11 {
        animation-delay: 0.1s;
      }
      .s12 {
        animation-delay: 0.11s;
      }
      .s13 {
        animation-delay: 0.12s;
      }
      .s14 {
        animation-delay: 0.13s;
      }
      .s15 {
        animation-delay: 0.14s;
      }
      .s16 {
        animation-delay: 0.15s;
      }
    }
  }

  @keyframes bckScale {
    0% {
      z-index: 100;
      opacity: 0.2;
    }
    20% {
      transform: scale(1.2);
    }
    60% {
      overflow: hidden;
    }
  }

  @keyframes zIndex {
    0% {
      z-index: 100;
      opacity: 0.2;
    }
    20% {
      transform: scale(1.1);
    }
    40% {
      transform: scale(0.2);
    }
    60% {
      z-index: 1;
    }
  }

  @keyframes scaleSquare1 {
    0% {
      opacity: 0.2;
      -webkit-filter: blur(10px);
      filter: blur(10px);
    }
    30% {
      transform: scale(0.3);
      -webkit-filter: blur(0px);
      filter: blur(0px);
    }
    60% {
      transform: scale(1);
      opactiy: 0.8;
    }
    70%,
    100% {
      transform: scale(1);
      height: 20px;
      width: 20px;
      opacity: 1;
    }
  }
`;

const Loading = (props) => {
  return (
    <StyledLoading>
      <NanoFlex flexDirection={"column"}>
        <div className="loading-container">
          <div className="icon-background">
            <div className="icon-wrapper">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M80 0H0V80H80V0ZM23.0627 9.36483H11V73H26.5328V35.2966L55.2849 73H69V8L53.4672 10.9003V48.9449L23.0627 9.36483Z" fill="white" />
              </svg>
            </div>
          </div>

          <div className="squaresContainer">
            <div className="square s1"></div>
            <div className="square s2"></div>
            <div className="square s3"></div>
            <div className="square s4"></div>
            <div className="square s5"></div>
            <div className="square s6"></div>
            <div className="square s7"></div>
            <div className="square s8"></div>
            <div className="square s9"></div>
            <div className="square s10"></div>
            <div className="square s11"></div>
            <div className="square s12"></div>
            <div className="square s13"></div>
            <div className="square s14"></div>
            <div className="square s15"></div>
            <div className="square s16"></div>
          </div>
        </div>
      </NanoFlex>
    </StyledLoading>
  );
};

export default Loading;

// --- // Documentation // --- //
/*

import Loading from './../Nano/Loading.js';

<Loading />
*/
